import axiosConfig from '@/sso/axios-config'
import { filterParameters } from '@/util/common'

export async function list(condition, currPage, pageSize) {
  //拆分时间
  if (condition.logtime != null && condition.logtime.length > 0) {
    condition.logtimeStart = condition.logtime[0]
    condition.logtimeEnd = condition.logtime[1]
  } else {
    condition.logtimeStart = null
    condition.logtimeEnd = null
  }

  const copy = filterParameters(condition)
  delete copy['logtime']

  const data = {
    currPage,
    pageSize,
    condition: copy,
  }

  return await axiosConfig.service({
    url: '/channel/withData',
    method: 'post',
    data: data,
  })
}
